import { useRef } from "react";

/** Preserve the last record while a controlled overlay runs its exit and restores focus. */
export function useRetainedValue<T>(value: T | null | undefined): T | undefined {
  const previous = useRef<T | undefined>(undefined);
  if (value != null) previous.current = value;
  return value ?? previous.current;
}
